import styled from 'styled-components';
import { glassEffect } from '../../theme';

export const FormPageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;

export const FormBox = styled.div`
  ${glassEffect}
  width: 400px;
  padding: 40px;
  border-radius: 16px;
`;

export const FormTitle = styled.h1`
  text-align: center;
  color: ${({ theme }) => theme.heading};
  margin-bottom: 30px;
  font-weight: 600;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 15px;
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 8px;
  font-size: 16px;
  background-color: ${({ theme }) => theme.inputBg};
  color: ${({ theme }) => theme.heading};
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const Button = styled.button`
  width: 100%;
  padding: 12px 15px;
  background-color: ${({ theme }) => theme.primary};
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
`;

// --- NEW STYLE FOR THE GOOGLE BUTTON ---
export const GoogleButton = styled.button`
  width: 100%;
  padding: 12px 15px;
  background-color: transparent;
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.cardBorder};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.navActiveBg};
  }
`;

// A simple separator style
export const Separator = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${({ theme }) => theme.text};
  margin: 25px 0;

  &::before, &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid ${({ theme }) => theme.cardBorder};
  }
  &:not(:empty)::before {
    margin-right: .25em;
  }
  &:not(:empty)::after {
    margin-left: .25em;
  }
`;